export const RESET = 'CONTACTTYPE_UPDATE_RESET'
export const SET_ERROR = 'CONTACTTYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'CONTACTTYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'CONTACTTYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'CONTACTTYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'CONTACTTYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'CONTACTTYPE_UPDATE_UPDATE_RETRIEVED'



// WEBPACK FOOTER //
// ./src/store/modules/contact_type/update/mutation_types.js